import { submitEmail } from "@/app/database/standard/firebase";
import { handleButtonTracking } from "@/app/utils/button-tracking";
import { useState } from "react";

export const EmailModal = ({ id, title, desc, cta, tracking, onSuccess }) => {
  const [isLoading, setIsLoading] = useState(false);

  return (
    <dialog id={id} className="modal">
      <div className="modal-box bg-panel border border-line">
        <h3 className="font-bold text-lg text-white">{title}</h3>
        <p className="py-4 text-zinc-400">{desc}</p>
        <form
          onSubmit={async (e) => {
            e.preventDefault();
            setIsLoading(true);
            handleButtonTracking(tracking);
            const email = (e.target as HTMLFormElement).email.value;

            await submitEmail(email);
            onSuccess();
            setIsLoading(false);
          }}
          className="space-y-4 flex flex-col items-center"
        >
          <input
            type="email"
            name="email"
            required
            placeholder="Email"
            className="input input-bordered w-full bg-ink-soft border-line text-white placeholder-zinc-500 focus:border-primary focus:ring-primary/30"
          />

          {isLoading ? (
            <>
              <span className="loading loading-spinner loading-lg text-primary"></span>
            </>
          ) : (
            <>
              <button
                type="submit"
                className="btn btn-ghost text-white bg-primary hover:bg-secondary w-full transition-all"
              >
                {cta}
              </button>
            </>
          )}
        </form>
      </div>

      <form method="dialog" className="modal-backdrop">
        <button>close</button>
      </form>
    </dialog>
  );
};
